export default "__VITE_ASSET__52b5ac93__$_?nuxt_component=async__"